export const MIN_RATING_COUNTER = 5;

export const MIN_NUMBER_OF_BOOKINGS = 5;

export const TRAIT_SCORE_MINIMUM = 5;

export const CRITICAL_SORT_VALUE = 'rating';
export const RECENT_SORT_VALUE = 'createdAt-';
export const POSITIVE_SORT_VALUE = 'rating-';

export const INFO_TAB_NAME = 'info';
export const REVIEWS_TAB_NAME = 'reviews';
export const SERVICES_TAB_NAME = 'services';
export const BIO_TAB_NAME = 'bio';

export const MAX_REVIEW_LENGTH = 250;

export const NUMBER_OF_REVIEWS_PER_REQUEST = 20;

export const MIN_STAR_REVIEW = 1;
export const MAX_STAR_REVIEW = 5;



// WEBPACK FOOTER //
// ./spa/Components/Reviews/values.jsx